import type { Data } from '@wix/thunderbolt-becky-types'
import { shapeIdsNode as shapeIds } from './shapeIdsNode'
import { cursorShapeIdsNode as cursorShapeIds } from './cursorShapeIdsNode'
import { getInvalidationHandler } from './invalidationHandler'
import type { IocContainer } from '@wix/thunderbolt-ioc'
import { CompNodeProviderSymbol, OnInvalidationSymbol } from '@wix/thunderbolt-catharsis-ioc'

const RELEVANT_DATA_MAPS: Array<keyof Data> = [
	'document_data',
	'design_data',
	'component_properties',
	'theme_data',
	'cursor',
	'variants_data',
	'innerElements',
]

export const addInvalidation = (container: IocContainer): Set<string> => {
	const set = new Set<string>()

	const onInvalidation = getInvalidationHandler(set)
	container.bind(OnInvalidationSymbol).toConstantValue(onInvalidation)

	container.bind(CompNodeProviderSymbol).toConstantValue({
		getCompNodes: () => ({ shapeIds, cursorShapeIds }),
		getUsedDataMaps: () => RELEVANT_DATA_MAPS,
	})

	return set
}
